import { render, staticRenderFns } from "./p25.vue?vue&type=template&id=341cac0c&scoped=true&"
import script from "./p25.vue?vue&type=script&lang=js&"
export * from "./p25.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341cac0c",
  null
  
)

export default component.exports